import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _each from 'lodash/each';
import * as AppActions from '../../actions/AppActions';
import * as FPT from '../../utility/fpt';
import appStore from '../../stores/AppStore';
import { localsMessages } from '../../utility/getTemplateData';
import { DropdownMenu } from '@paypalcorp/pp-react';
const messages = localsMessages('common/programs');
class Programs extends Component {
  static propTypes = {
    programNames: PropTypes.array,
  };

  componentDidMount() {
    appStore.on('change', this.updateView);
  }

  componentWillUnmount() {
    appStore.removeListener('change', this.updateView);
  }

  updateView = (params) => {
    this.setState({});
  };

  updateSelectedProgram = (index) => {
    const selectedProgram =
      index === 0
        ? ''
        : this.getProgramOptions(this.props.programNames)[index].primaryText;
    AppActions.updateSelectedProgram(selectedProgram);
    FPT.trackLinkClickWithData('campaignSelected', {
      campaign: selectedProgram,
    });
  };

  getProgramOptions = (programNames) => {
    const options = [{ primaryText: messages.programs.optional }];
    _each(programNames, (programName) => {
      options.push({
        primaryText: programName,
      });
    });

    return options;
  };

  render() {
    const { programNames } = this.props;
    let selectedProgramIdx = this.getProgramOptions().findIndex(
      (program) => program.primaryText === appStore.getSelectedProgram()
    );
    selectedProgramIdx = selectedProgramIdx < 0 ? 0 : selectedProgramIdx;

    return (
      <DropdownMenu
        type="button"
        className="dropdown-wide mt-16 mb-16"
        data-testid="programs-drowpdown"
        selectedItemIndex={selectedProgramIdx}
        onSelection={this.updateSelectedProgram}
        options={this.getProgramOptions(programNames)}
      />
    );
  }
}
export default Programs;
